import { Injectable, NgZone, OnDestroy, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { BehaviorSubject, catchError, lastValueFrom, map, retry, Subject, Subscription, throwError, timeout } from 'rxjs';
import { Logger } from '@app/core';
import { AuthenticationService } from '@app/core';
import { Constants, EVENT_NAMES, EVENT_TYPES } from '@app/constants';
import { TelephonyProvider } from '../providers/telephony/telephony.provider';
import { Router } from '@angular/router';
import { momentCustom as momentc, momentCustomInstance as momentInst, parseGoogleAddress } from '@projects/shared/src/app/utils/helper';
import { SignalrService } from '@app/core/signalr.service';
import { RealTimeEvents } from '@app/core/signalr.events';
import { ToastService } from './toast/toast.service';
import { DialpadService } from './dialpad.service';
import { appendLeadingZeros, FormattedEmail } from '@app/core/helpers';
import { IntegrationService } from './integration.service';
import { TelephonyStateService } from '../providers/telephony/telephony.state.service';
import { AppConfigurationService } from './app.configuration.service';
import { naturalSensitiveSort } from '../utils/sort';
import momentTimezone from 'moment-timezone';
import moment from 'moment';
import { NavService } from './nav.service';
import { BdServiceableProvider } from './app.config.type';

const log = new Logger('CampaignService');
declare let google: any;

@Injectable({
  providedIn: 'root',
})
export class CampaignService implements OnInit, OnDestroy {
  subscriptions = new Array<Subscription>(); 
  scriptReview = {
    searchButtonDisabled: false
  }
  constructor(
    private httpClient: HttpClient,
    private fb: FormBuilder,
    private telephony: TelephonyProvider,
    private authService: AuthenticationService,
    private router: Router,
    private signalrService: SignalrService,
    private dialpadService: DialpadService,
    private zone: NgZone,
    private integrationService: IntegrationService,
    private telephonyStateService: TelephonyStateService,
    private appConfig: AppConfigurationService,
    private navService: NavService
  ) {
    this.subscriptions.push(
      this.telephony.voice.events.subscribe(async (event) => {
        switch (event.type) {
          case 'Call':
            switch (event.name) {
              case 'accept':
                const {
                  campaignId,
                  callSid,
                  callType,
                  btn,
                  tfn,
                  campaignCode,
                  campaignName,
                  langCode,
                  leadId,
                  tfnCampaignId,
                  tfnCampaignCode,
                  tfnCampaignName,
                  isCallBack,
                  headers
                } = event.data;
                this.playAudio();
                this.connectedCallObj = { ...event.data };
                this.todayScheduledCallbacksDialingType = event.data.dialing_type;
                if (callSid) {
                  this.customerCallSid = callSid;
                }
                try {
                  this.setCountryCode(btn);
                  this.hideAnyScriptFeature(tfnCampaignCode);
                  this.callType = callType.replace(/\b[a-z]/g, (x: any) => x.toUpperCase());

                  //* Bits Activition
                  this.providerBitActivition(btn, tfnCampaignCode, tfn);
                  this.btn = btn;
                  this.campaignCode = tfnCampaignCode;
                  this.campaignName.next(campaignName);
                  if (this.callType == 'Inbound') {
                    this.isEmailOptoutToggle = this.getScriptSkillCode('EMAIL_REMOVE_TFNS')?.includes(tfn);
                  }
                  if (callType == 'outbound') {
                    this.showCallDetails = true;
                    //if call dialed form callback grid
                    if (isCallBack) {
                      this.getCampainMetadata(tfnCampaignId);
                    } else {
                      this.getCampainMetadata(campaignId);
                    }
                  } else if (callType == 'inbound') {
                    this.getCampainMetadata(tfnCampaignId);
                    this.showCallDetails = true;
                  }
                  //*PK Ghost Call Disposition Work
                  this.ghostCallDispositionInterval();

                } catch (error) {
                  console.error(error);
                  log.error('Error in campaign service call accept', JSON.stringify(error));
                }


                this.leadId = leadId;


                try {
                  this.getTFNDetail(tfn, langCode);
                } catch (error) {
                  log.error('Error in fetching TFN details', JSON.stringify(error));
                }
                if (headers) {
                  headers.CallSid = callSid;
                }
                !this.isAnyPortmoreSkill && this.getLead(btn, tfn, headers);
                //* portmore
                //* for outbound get data from our DB
                //* for inbound don't
                this.isAnyPortmoreSkill && callType === 'inbound' && this.getUSHLeadInbound(btn, tfn, headers);
                this.isAnyPortmoreSkill && callType === 'outbound' && this.getLead(btn, tfn, '');
                (this.isAnyPortmoreSkill || this.isPK_Call) && this.chnageWorkbenchToWithWorkBench();


                this.zone.run(() => {
                  //this.scriptDecider();
                  this.router.navigate(['/agent/calls/campaign']);
                });

                this.isCallConnected.next(true);

                this.assignCall(
                  this.customerCallSid,
                  this.authService.authData.Id,
                  this.authService.authData.UserSettings?.IbexId,
                  leadId
                );
                this.getLastCall(this.customerCallSid, this.btn);

                break;
              case 'dispose':
                if (this.showCallDetails) {
                  this.showCallDetails = false;
                  this.createForceDisposeLeadData(this.lead);
                }
                if (this.isPGECall || this.isUSH_Call) await this.bdCallDisposition(event.data.callSid);
                //this.resetCampaign();
                await this.updateCallLead(event.data.callSid, event.data.lead, event.data.callback);
                //if (this.isPGECall) await this.bdCallDisposition(sid);
                break;
              case 'ibex-dispose':
                this.cancelThirdParty = this.telephonyStateService.cancelThirdParty;
                break;
              case 'assign':
                const callsid = event.data;
                this.assignCall(
                  callsid,
                  this.authService.authData.Id,
                  this.authService.authData.UserSettings?.IbexId,
                  ''
                );
                break;
              case 'conference':
                this.conferenceSid = event.data;
                break;
            }
            break;
          case 'Reservation':
            switch (event.name) {
              case 'received':
                const { callSid, callType, btn } = event.data;
                this.btn = btn;
                this.callType = callType.replace(/\b[a-z]/g, (x: any) => x.toUpperCase());
                this.showCallDetails = true;
                break;
              case 'accepted':
                if (!this.primaryCampaign.AutoAcceptCall) {
                  this.showCallDetails = false;
                }
                break;
              case 'rejected':
              case 'timeout':
              case 'canceled':
              case 'rescinded':
                this.showCallDetails = false;
                this.resetCampaign();
                break;
            }
            break;
          case 'Conference':
          case 'Consult':
            switch (event.name) {
              case 'init':
                //update customer info on contact...
                const sid = event.data.callSid;
                await this.updateContactInfo(sid);
                break;
            }
            break;
          case 'Transfer':
            switch (event.name) {
              case 'completed':
                if (event.data && this.isChatSkillCall) {
                  this.dispositionForm.controls['chatTfn'].setValidators([Validators.required, this.phoneValidator]);
                  this.dispositionForm.controls['chatTfn'].updateValueAndValidity();
                  this.showChatTfnTextbox = true;
                }
                break;
            }
            break;
        }
      })
    );
    this.dispositionForm.controls['dispositionGroup'].valueChanges.subscribe((selectedValue: any) => {
      this.onDispositionGroupChange(selectedValue);
    });
    this.dispositionForm.controls['disposition'].valueChanges.subscribe((dispositionValue: any) => {
      //! Star Link Disposition reason required validator addition
      if (dispositionValue && this.getScriptSkillCode('STAR_LINK_SKILLCODE').includes(this.campaignCode)) {
        let disposition: { Id: string; Name: string } = this.dispositions.find(
          (x: { Id: string; Name: string }) => x.Id == dispositionValue
        ) || { Id: '', Name: '' };
        if (this.stopReasonCodes.includes(disposition.Name)) {
          this.showReasonDropDown = false;
          this.dispositionForm.controls['reasons'].clearValidators();
        } else {
          this.showReasonDropDown = true;
          this.dispositionForm.controls['reasons'].setValidators([Validators.required]);
        }
        this.dispositionForm.controls['reasons'].updateValueAndValidity();
      }
      //! Ziply Disposition "Not interested" otherReasons required validator addition
      else if (dispositionValue && (this.getScriptSkillCode('ZIPLY_SKILLCODE') || '').includes(this.campaignCode)) {
        let disposition: { Id: string; Name: string } = this.dispositions.find(
          (x: { Id: string; Name: string }) => x.Id == dispositionValue
        ) || { Id: '', Name: '' };

        this.showOtherReasonTextBox = Constants.ZIPLY_SHOW_OTHER_REASONS_DISPOSITIONS.includes(disposition.Name)
          ? true
          : false;
      }
    });
    this.dispositionForm.controls['reasons'].valueChanges.subscribe((reasonsValue: any) => {
      if (reasonsValue && reasonsValue.length > 0) this.showOtherReasonTextBox = reasonsValue.includes('Other');
    });
    this.dispositionForm.controls['disposition'].valueChanges.subscribe((selectedValue: any) => {
      console.log('disposition:::251', selectedValue);
      let disposition: any =
        this.dispositions.find((x: any) => x.Id == this.dispositionForm.controls['disposition'].value) || { Id: '', Name: '' };
      this.dispositionCallbackSelection = disposition.Name;
      console.log('dispositionCallbackSelection:::251', this.dispositionCallbackSelection);
      if (this.dispositionCallbackSelection == 'Callback Scheduled') {
        this.dispositionForm.controls['callbackTimezone'].setValidators([Validators.required]);
        this.dispositionForm.controls['callbackDate'].setValidators([Validators.required]);
        this.dispositionForm.controls['callbackHour'].setValidators([Validators.required]);
        this.dispositionForm.controls['callbackMins'].setValidators([Validators.required]);
      } else {
        this.dispositionForm.controls['callbackTimezone'].clearValidators();
        this.dispositionForm.controls['callbackDate'].clearValidators();
        this.dispositionForm.controls['callbackHour'].clearValidators();
        this.dispositionForm.controls['callbackMins'].clearValidators();
      }
      this.dispositionForm.controls['callbackTimezone'].updateValueAndValidity();
      this.dispositionForm.controls['callbackDate'].updateValueAndValidity();
      this.dispositionForm.controls['callbackHour'].updateValueAndValidity();
      this.dispositionForm.controls['callbackMins'].updateValueAndValidity();
    });
    this.greetingForm.controls['isConfirmPhoneNumber'].valueChanges.subscribe((selectedValue: any) => {
      if (!selectedValue) {
        this.greetingForm.controls['confirmPhoneNumber'].addValidators([Validators.required]);
      } else {
        if (!this.greetingForm.controls['confirmPhoneNumber'].valid && !this.isFPLPhoneNumbers) {
          this.greetingForm.controls['confirmPhoneNumber'].setValue(
            this.lead.CustomerInfo?.ConfirmBtn?.slice(this.countryCode.length) ?? ''
          );
          this.greetingForm.controls['confirmPhoneNumber'].clearValidators();
        }
      }
      this.greetingForm.controls['confirmPhoneNumber'].updateValueAndValidity();
    });
    this.greetingForm.controls['isConfirmCallbackNumber'].valueChanges.subscribe((selectedValue: any) => {
      if (!selectedValue) {
        this.greetingForm.controls['confirmCallbackNumber'].addValidators([Validators.required]);
      } else {
        if (!this.greetingForm.controls['confirmCallbackNumber'].valid && !this.isFPLPhoneNumbers) {
          this.greetingForm.controls['confirmCallbackNumber'].setValue(
            this.lead.CustomerInfo?.ConfirmBtn?.slice(this.countryCode.length) ?? ''
          );
          this.greetingForm.controls['confirmCallbackNumber'].clearValidators();
        }
      }
      this.greetingForm.controls['confirmCallbackNumber'].updateValueAndValidity();
    });
    this.greetingForm.controls['isSendSummaryEmail'].valueChanges.subscribe((selectedValue: any) => {
      if (selectedValue) {
        this.greetingForm.controls['sendSummaryEmail'].setValidators([Validators.required, Validators.email]);
      } else {
        this.greetingForm.controls['sendSummaryEmail'].clearValidators();
      }
      this.greetingForm.controls['sendSummaryEmail'].updateValueAndValidity();
    });
    //* if yes check for email
    this.greetingForm.controls['isSurveyByEmail'].valueChanges.subscribe((isSurveyByEmailValue: any) => {
      if (isSurveyByEmailValue) {
        this.greetingForm.controls['surveyEmail'].setValidators([Validators.required, Validators.email]);
      } else {
        this.greetingForm.controls['surveyEmail'].clearValidators();
      }
      this.greetingForm.controls['surveyEmail'].updateValueAndValidity();
    });
    //* if yes check for number
    this.greetingForm.controls['isSurveyByMobile'].valueChanges.subscribe((isSurveyByMobileValue: any) => {
      if (isSurveyByMobileValue) {
        this.greetingForm.controls['selectedSMSNumber'].setValidators([Validators.required]);
        this.getSMSNumbers();
      } else {
        this.greetingForm.controls['selectedSMSNumber'].clearValidators();
        this.greetingForm.controls['selectedSMSNumber'].reset();
        this.greetingForm.controls['surveyNumber'].reset();
        this.greetingForm.controls['surveyNumber'].clearValidators();
        this.greetingForm.controls['surveyNumber'].updateValueAndValidity();
      }
      this.greetingForm.controls['selectedSMSNumber'].updateValueAndValidity();
    });
    //survey validations set
    this.greetingForm.controls['isSurveyTCPA'].valueChanges.subscribe((isSurveyTCPAValue: any) => {
      //* Survey yes,no check
      if (isSurveyTCPAValue) {
      } else {
        // this.greetingForm.controls['surveyEmail'].reset();
        this.greetingForm.controls['selectedSMSNumber'].reset();
        this.greetingForm.controls['surveyNumber'].reset();
        this.greetingForm.controls['surveyEmail'].clearValidators();
        this.greetingForm.controls['selectedSMSNumber'].clearValidators();
        this.greetingForm.controls['surveyNumber'].clearValidators();
        this.greetingForm.controls['surveyEmail'].updateValueAndValidity();
        this.greetingForm.controls['selectedSMSNumber'].updateValueAndValidity();
        this.greetingForm.controls['surveyNumber'].updateValueAndValidity();
      }
    });
    this.greetingForm.controls['selectedSMSNumber'].valueChanges.subscribe((selectedSMSNumberValue: any) => {
      if (selectedSMSNumberValue === 'Other') {
        this.greetingForm.controls['surveyNumber'].setValidators([Validators.required]);
      } else {
        this.greetingForm.controls['surveyNumber'].clearValidators();
      }
      this.greetingForm.controls['surveyNumber'].updateValueAndValidity();
    });

    this.greetingForm.controls['utlitityConfirmationEmail'].valueChanges.subscribe((value: any) => {
      //* Empty Check
      if (value.length !== 0) {
        this.greetingForm.controls['sendSummaryEmail'].setValue(value);
        this.greetingForm.controls['surveyEmail'].setValue(value);
        this.addressForm.controls['email'].setValue(value);
      }
    });
    this.greetingForm.controls['isSupplier'].valueChanges.subscribe((value: any) => {
      if (!value) {
        this.greetingForm.controls['supplier'].setValue('Random');
      }
    });
    this.greetingForm.controls['isEmailOptout'].valueChanges.subscribe((isEmailSubscribedValue: any) => {
      if (isEmailSubscribedValue) {
        this.greetingForm.controls['email'].setValidators([Validators.required, Validators.email]);
        const addressEmail = this.addressForm.get('email')?.value;
        this.greetingForm.controls['email'].setValue(addressEmail || '');
      } else {
        this.greetingForm.controls['email'].clearValidators();
        this.greetingForm.controls['email'].setValue('');
      }
      this.greetingForm.controls['email'].updateValueAndValidity();
    });
    this.greetingForm.controls['confirmPhoneNumber'].valueChanges.subscribe((selectedValue: any) => {
      if (selectedValue && this.isFPLPhoneNumbers) {
        this.greetingForm.controls['confirmCallbackNumber'].setValue(selectedValue);
      }
    });
    // this.greetingForm.controls['timeZone'].valueChanges.subscribe((timeZoneValue: any) => {
    //   const selectedMeetingDate: any = this.greetingForm.controls['meetingStartDate'].value;
    //   if (timeZoneValue) {
    //     //console.log(new Date().toLocaleString() + '  ➤  timeZoneValue ==> ', timeZoneValue);
    //     let startChangedDate = momentInst(selectedMeetingDate).tz(timeZoneValue, true);

    //     this.greetingForm.controls['meetingStartDate'].setValue(startChangedDate);
    //   }
    // });
    // this.greetingForm.controls['meetingStartDate'].valueChanges.subscribe((meetingStartDate: any) => {
    //   if (meetingStartDate) {
    //     let tz: string = this.greetingForm.controls['timeZone'].value || '';
    //     let endChangedDate = momentInst(meetingStartDate)
    //       .tz(tz, true)
    //       .add(+this.ziplyMeetingMin, 'minutes');
    //     this.greetingForm.controls['meetingEndDate'].setValue(endChangedDate);
    //     //console.log(new Date().toLocaleString() + '  ➤  meetingStartDate ==> ', momentInst(this.greetingForm.controls['meetingStartDate'].value).format());
    //     //console.log(new Date().toLocaleString() + '  ➤  meetingEndDate ==> ', momentInst(this.greetingForm.controls['meetingEndDate'].value).format());
    //   }
    // });
    // this.greetingForm.controls['isMeetingDate'].valueChanges.subscribe((isMeetingDate: any) => {
    //   if (isMeetingDate !== null || isMeetingDate !== undefined)
    //     if (isMeetingDate) {
    //       this.greetingForm.controls['meetingSource'].setValidators([Validators.required]);
    //       this.greetingForm.controls['meetingSource'].enable();
    //       this.greetingForm.controls['meetingSource'].updateValueAndValidity();
    //     } else {
    //       this.greetingForm.controls['meetingSource'].setValue('');
    //       this.greetingForm.controls['meetingSource'].clearValidators();
    //       this.greetingForm.controls['meetingSource'].disable();
    //       this.greetingForm.controls['meetingSource'].updateValueAndValidity();
    //     }
    // });
    this.subscriptions.push(
      this.signalrService.listen(RealTimeEvents.OutboundCallInit).subscribe((call: any) => {
        console.log(`Signal event => OutboundCallInit received with data ${call.callSid}, ${call.agentIdentity}`);
        if (call.agentIdentity == FormattedEmail(this.authService.authData.Username, false)) {
          this.customerCallSid = call.callSid;
          localStorage.setItem('activeCallSid', call.callSid);
          this.telephony.voice.setOutboundCallSid(null, call.callSid);
          this.telephony.voice.events.next({ type: 'Call', name: 'callsid', data: call.callSid });
        }
      })
    );
    this.subscriptions.push(
      // Subscribe to changes in the entire form array
      this.sales.valueChanges.subscribe(() => {
        // Call a method to manually re-validate ocn controls
        this.updateOCNDuplicateValidation();
      })
    );
  }
  ngOnInit(): void {

  }

  isPGECall = false;
  isPGESpanishCall = false;
  isFPL_NRG_Call = false;
  isSTAR_LINK_Call = false;
  isZIPLY_Call = false;
  isUSH_Call = false;
  isPK_Call = false;
  isPortmoreCall = false;
  isNICCall = false;
  isTikTokCall = false;
  isChatSkillCall = false;
  isAnyPortmoreSkill = false;
  isSierraCall = false;
  isEmailOptoutToggle = false;
  connectedCallObj: any = {};
  todayScheduledCallbacksDialingType: string = ''
  stepsConstants = [
    { label: 'Greeting', icon: 'fa-light fa-hand-wave' },
    { label: 'Address', icon: 'fa-light fa-square-user' },
    { label: 'OET', icon: 'fa-light fa-ballot-check' },
    { label: 'Sales', icon: 'fa-light fa-square-list' },
  ];
  steps = [
    { label: 'Greeting', icon: 'fa-light fa-hand-wave' },
    { label: 'Address', icon: 'fa-light fa-square-user' },
    { label: 'OET', icon: 'fa-light fa-ballot-check' },
    { label: 'Sales', icon: 'fa-light fa-square-list' },
  ];
  starlinkInboundSteps = [
    { label: 'Greeting', icon: 'fa-light fa-hand-wave' },
    { label: 'Address', icon: 'fa-light fa-square-user' },
    { label: 'Sales', icon: 'fa-light fa-square-list' },
  ];
  scriptName = 'default';
  isCallAssigned: boolean = false;
  callType: string = '';
  showCallDetails: boolean = false;
  btn: string = '';
  campaignCode: string = '';
  campaignName = new BehaviorSubject<string>('Campaign');
  customerCallSid = '';
  countryCode: string = '+1';
  lead: any = {};
  lastCall: any = {};
  greeting: any = Constants.GREETING;
  tfnFlow: string = '';
  primaryCampaign: any = {};
  metadata: any = [];
  transferNumbers: any[] = [];
  dispositionGroups = [];
  selectedDispositionGroup: string = '';
  selectedDisposition: string = '';
  dispositions = [];
  timezones = [];
  selectedTimezone: string = '';
  bundleDealerURl: string = '';
  isCustomerInfoChanged: boolean = true;
  isFirstSeassion: boolean = true;
  changableFormData: any = {
    address: '',
    zip: '',
    firstName: '',
    lastName: '',
    phn: '',
    email: '',
    residentType: '',
    apartment: '',
  };
  stepperIndex: number = 0;
  //* Campaign Call Connection Event Variable
  //? Replace this with actual call event
  //? --> true call is connected/ false call is not connected
  isCallConnected = new BehaviorSubject<boolean>(false);
  notes: string = '';
  showNotes: boolean = false;
  confirmNumber = '';
  isConfirmNumber = false;
  ghostCallTimeoutId: any = null;

  //* Bundle dealer session id variable
  sessionid: string = '';
  smsNumbers: any = [];
  accountType: any = [];
  ziplyMeetingSource: any = [
    // {
    //   label: 'Email',
    //   value: 'Email',
    // },
    {
      label: 'Phone',
      value: 'Phone',
    },
  ];
  ziplyTimeZones: any = [
    // {
    //   label: 'EST',
    //   value: 'America/New_York',
    // },
    {
      label: 'PT',
      value: 'America/Los_Angeles',
    },
    // {
    //   label: 'CT',
    //   value: 'America/Chicago',
    // },
    {
      label: 'MT',
      value: 'America/Denver',
    },
  ];
  ziplyMeetingMin: string = '30';
  isCustomerAvailableForMeeting: boolean = true;

  lastRouteBeforeCall: string = '';
  isMockCall = false;
  providerCustomerData: any = {};

  //* StarLink
  message: any = '';
  reasons = [];
  showReasonDropDown: boolean = false;
  showOtherReasonTextBox: boolean = false;
  finalizedDipositionsForReasons: Array<string> = [];
  stopReasonCodes: Array<string> = [
    'Custom Order 10+ Kits',
    'Voicemail',
    'Ring No Answer',
    'Callback Scheduled',
    'Plan To Purchase',
    'Maritime Cold Call',
    'Sale'
  ];
  starLinkFinalizedDispositions: Array<string> = [
    'Custom Order 10+ Kits',
    'Plan To Purchase',
    'Invalid Number',
    'Language Barrier',
    'Not Interested',
    'Unconfirmed Profilel',
    'Seeking Information',
    'Upsell',
    'Existing Customer Support',
  ];
  provider_fields: Array<string> = [];
  db_fields: Array<string> = [];
  leadId = '';
  showChatTfnTextbox = false;
  $metaDataChange = new Subject();
  //USH FE
  suppliers = [
    {
      key: 'Random',
      value: 'Random',
    },
  ];
  disableResidentRadio: boolean = false;

  //* Greeting Form
  initialGreetingFormValue = {
    firstName: '',
    lastName: '',
    accountType: '',
    customerType: '',
    meetingSource: '',
    timeZone: 'America/Los_Angeles',
    isConfirmPhoneNumber: false,
    isMovingDateChanged: false,
    movingDate: momentInst(),
    //meetingStartDate: momentInst().tz('America/Los_Angeles', true),
    //meetingEndDate: momentInst().tz('America/Los_Angeles', true),
    //isMeetingDate: false,
    utlitityConfirmationEmail: '',
    primaryInterest: '',
    companyName: '',
    jobTitle: '',
    accountOwner: '',
    currentProvider: '',
    sendSummaryEmail: '',
    isSendSummaryEmail: false,
    confirmPhoneNumber: '',
    isConfirmCallbackNumber: false,
    confirmCallbackNumber: '',
    isSurveyTCPA: false,
    isSurveyByEmail: false,
    isSurveyByMobile: false,
    surveyEmail: '',
    selectedSMSNumber: '',
    surveyNumber: '',
    questionsAnsweres: [],
    supplier: 'Random',
    isSupplier: false,
    isEnroll: false,
    isResidentCorrect: false,
    isEnrolledInProgram: false,
    isEmailOptout: false,
    email: ""
  };
  greetingForm = this.createGreetingForm();

  //* Address Form
  initialAddressFormValue = {
    address: '',
    email: '',
    apartment: '',
    zip: '',
    city: '',
    state: '',
    resident: 'Residential',
    residentType: 'Renter',
    customerType: 'N',
    workoutBench: 'WithoutWorkBench',
    mapData: ''
  };
  addressForm = this.fb.group({
    address: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9 ,-/.#()&]{0,50}$/)]],
    email: ['', [Validators.required, Validators.email]],
    //apartment: [''],
    apartment: ['', [Validators.pattern(/^[a-zA-Z0-9 #/_-]{0,50}$/)]],
    zip: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]],
    city: ['', [Validators.required, Validators.pattern(/^[a-zA-Z #'/_-]{0,50}$/)]],
    state: ['', [Validators.required, Validators.pattern(/^[a-zA-Z #/_-]{0,50}$/)]],
    resident: ['Residential'],
    residentType: ['Renter'],
    customerType: ['N'],
    workoutBench: ['WithoutWorkBench'],
    mapData: ['']
  });

  //* Sales Form
  initialSalesFormValue: any = {
    accountNumber: '',
    addones: [],
    //sales: [this.createSaleFormGroup()],
  };
  addons = [];
  salesForm = this.fb.group({
    //* accountNumber extra field for portmore
    accountNumber: [''],
    chatTfn: [''],
    addones: [[]],
    sales: this.fb.array([this.createSaleFormGroup()], this.checkForDuplicatesOCN()),
  });
  //* Dialpad Disposition Form
  initialDispositionFormValue = {
    dispositionGroup: '',
    disposition: '',
  };
  dispositionForm: any = this.fb.group({
    dispositionGroup: ['', Validators.required],
    disposition: ['', Validators.required],
    reasons: [[]],
    otherReasons: [''],
    chatTfn: [''],
    addones: [[]],
    callbackTimezone: [''],
    callbackDate: [''],
    callbackHour: [''],
    callbackMins: [''],
  });
  private headers = { headers: new HttpHeaders({ hideLoader: 'true' }) };

  saleOrderLimit: number = 6;
  questionOrderLimit: number = 5;
  oetInfo: any = {
    oets: [
      { ID: 1, Value: 'Residential', show: true, source: '', viewsource: '' },
      { ID: 2, Value: 'Commercial', show: true, source: '', viewsource: '' },
    ],
    oetSessionIds: [],
    selectedOet: 'Residential',
    selectedOetURL: '',
    selectedOetSource: '',
    toShow: false,
    showError: false,
    errMessage: '',
  };
  conferenceSid = '';
  cancelThirdParty = false;
  bdServiceableProviders = [];
  bdServiceableProviderMessages: string[] = [];
  dispositionCallbackSelection: string = '';
  isFPLPhoneNumbers: any;
  tfnCampaignId:string = ''
  ngOnDestroy(): void {
    this.subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }
  //* Each Question Data
  createQuestionsFormGroup(): FormGroup {
    return new FormGroup({
      question: new FormControl(''),
      answer: new FormControl(''),
    });
  }
  //* Each Sale Data
  createSaleFormGroup(): FormGroup {
    return new FormGroup({
      ocn: new FormControl('', [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9 ,-/.#()&]{0,50}$'),
        Validators.maxLength(50),
      ]),
      mso: new FormControl('', Validators.required),
      rgu: new FormControl('', Validators.required),
      offerType: new FormControl('', Validators.required),
      deviceCount: new FormControl(''),
      pkSaleConfrimation: new FormControl(''),
      showExtraField: new FormControl(false),
      extraFieldName: new FormControl(''),
    });
  }
  createSaleFormGroupWithData(ocn: string, mso: string, rgu: Number, offerType: string): FormGroup {
    return new FormGroup({
      ocn: new FormControl(ocn, [Validators.required, Validators.maxLength(15)]),
      mso: new FormControl(mso, Validators.required),
      rgu: new FormControl(rgu, Validators.required),
      offerType: new FormControl(offerType, Validators.required),
      deviceCount: new FormControl(''),
      pkSaleConfrimation: new FormControl(''),
      showExtraField: new FormControl(false),
      extraFieldName: new FormControl(''),
    });
  }

  createQuestionsAnsweresFormGroupWithData(ques: string, ans: string): FormGroup {
    return new FormGroup({
      question: new FormControl(ques),
      answer: new FormControl(ans),
    });
  }

  createGreetingForm() {
    return this.fb.group({
      firstName: ['', [Validators.required, Validators.pattern('^[a-zA-Z]*$')]],
      lastName: ['', [Validators.required, Validators.pattern('^[a-zA-Z]*$')]],
      accountType: [''],
      customerType: '',
      meetingSource: [''],
      timeZone: ['America/Los_Angeles'],
      questionsAnsweres: this.fb.array([this.createQuestionsFormGroup()]),
      isConfirmPhoneNumber: [false],
      isMovingDateChanged: [false],
      movingDate: momentInst(),
      //meetingStartDate: momentInst().tz('America/Los_Angeles', true),
      //meetingEndDate: momentInst().tz('America/Los_Angeles', true),
      //isMeetingDate: [false],
      utlitityConfirmationEmail: [''],
      primaryInterest: [''],
      currentProvider: [''],
      companyName: [''],
      jobTitle: [''],
      accountOwner: [''],
      sendSummaryEmail: [''],
      isSendSummaryEmail: [false],
      confirmPhoneNumber: [''],
      isConfirmCallbackNumber: [false],
      confirmCallbackNumber: [''],
      isSurveyTCPA: [false],
      isSurveyByEmail: [false],
      isSurveyByMobile: [false],
      surveyEmail: [''],
      selectedSMSNumber: [''],
      surveyNumber: [''],
      description: [''],
      supplier: ['Random'],
      isSupplier: [false],
      isEnroll: [false],
      isResidentCorrect: [false],
      isEnrolledInProgram: [false],
      summary: [''],
      monthlyBill: [''],
      qualificationReason: [''],
      requestedServices: [''],
      serviceAddress: [''],
      isEmailOptout: [false],
      email: [''],
    });
  }
  // Return sales form salesForm
  get sales() {
    return this.salesForm.controls['sales'] as FormArray;
  }

  // Return questionsAnsweres form greetingForm
  get questionsAnsweres() {
    return this.greetingForm.controls['questionsAnsweres'] as FormArray;
  }

  // Check SaleForm sales Array
  checkSalesFieldValidation(index: number, fieldName: string) {
    let field: any = this.sales.controls[index].get(fieldName);

    return field.invalid && (field.dirty || field.touched);
  }

  // Check Field from same group form
  checkFieldValidation(fieldName: string, formGroupName: any) {
    return (
      formGroupName.get(fieldName).invalid &&
      (formGroupName.get(fieldName).dirty || formGroupName.get(fieldName).touched)
    );
  }

  // Access formcontrols getter & setters
  getField(fieldName: string, formGroupName: any) {
    return formGroupName.get(fieldName);
  }
  setField(fieldName: string, formGroupName: any, FiledData: any) {
    formGroupName.controls[fieldName].setValue(FiledData);
  }
  getGreetingsFieldValue<T>(fieldName: string): T {
    return this.greetingForm.get(fieldName)?.value;
  }
  getAddressFieldValue<T>(fieldName: string): T {
    return this.addressForm.get(fieldName)?.value;
  }
  getDispostionFormFieldValue<T>(fieldName: string): T {
    return this.dispositionForm.get(fieldName)?.value;
  }

  //* SMS Number
  getSMSNumbers() {
    if (this.greetingForm.controls['isSurveyTCPA'].value) {
      this.smsNumbers = [];
      this.smsNumbers.push({
        Label: 'Primary BTN | ' + this.greetingForm.controls['confirmPhoneNumber'].value,
        Value: this.greetingForm.controls['confirmPhoneNumber'].value,
      });
      //* Dont Push Callback Option For Portmore skills
      if (!this.isUSH_Call) {
        this.smsNumbers.push({
          Label: 'Callback No. | ' + this.greetingForm.controls['confirmCallbackNumber'].value,
          Value: this.greetingForm.controls['confirmCallbackNumber'].value,
        });
      }

      this.smsNumbers.push({ Label: 'Other', Value: 'Other' });
    }
  }
  //* SMS Number
  getSurveyMedium(): string {
    let medium: string = '';
    if (this.greetingForm.controls['isSurveyTCPA'].value) {
      if (this.greetingForm.controls['isSurveyByEmail'].value && this.greetingForm.controls['isSurveyByMobile'].value) {
        medium = 'both';
        return medium;
      }
      medium = this.greetingForm.controls['isSurveyByEmail'].value ? 'email' : 'sms';
    }
    return medium;
  }

  //* Form Value Change
  checkPrevoiusFormData() {
    //checvk for prevoius field changes
    if (
      this.changableFormData.address != this.addressForm.value.address ||
      this.changableFormData.zip != this.addressForm.value.zip ||
      this.changableFormData.apartment != this.addressForm.value.apartment ||
      this.changableFormData.residentType != this.addressForm.value.residentType ||
      this.changableFormData.firstName != this.greetingForm.value.firstName ||
      this.changableFormData.lastName != this.greetingForm.value.lastName ||
      this.changableFormData.customerType != this.greetingForm.value.customerType ||
      this.changableFormData.email != this.addressForm.value.email
    ) {
      this.isCustomerInfoChanged = true;
    } else {
      this.isCustomerInfoChanged = false;
    }
    // set new data to prevoius data variable
    this.changableFormData.address = this.addressForm.value.address;
    this.changableFormData.zip = this.addressForm.value.zip;
    this.changableFormData.residentType = this.addressForm.value.residentType;
    this.changableFormData.firstName = this.greetingForm.value.firstName;
    this.changableFormData.lastName = this.greetingForm.value.lastName;
    this.changableFormData.customerType = this.greetingForm.value.customerType;
    this.changableFormData.apartment = this.addressForm.value.apartment;
    this.changableFormData.email = this.addressForm.value.email;
  }

  async getPrimaryCampaignSettings(id: string) {
    log.info('Getting primary settings');
    const response: any = await lastValueFrom(
      this.httpClient.get(`${Constants.APIS.CAMPAIGN.PRIMARY_CAMPAIGN_SETTINGS}/${id}`, this.headers)
    );
    this.primaryCampaign = response;
    return response;
  }
  async getCampainMetadata(id: string) {
    log.info('Getting primary settings');
    const response: any = await lastValueFrom(
      this.httpClient.get(`${Constants.APIS.CAMPAIGN.META_DATA}/${id}`, this.headers)
    );
    this.metadata = response.MetaData;
    this.transferNumbers = this.metadata?.Transfers.filter((x: any) => x.Name != '' || x.Name == undefined);
    this.dispositionGroups = this.metadata?.Dispositions.map((x: any) => x.GroupName)
      .filter((value: any, index: any, self: any) => self.indexOf(value) === index)
      .map((y: any) => ({ Group: y }));
    //Sort

    this.dispositionGroups = naturalSensitiveSort(this.dispositionGroups).asc('Group');
    this.timezones = this.metadata?.Timezones;
    this.$metaDataChange.next(this.metadata);
  }
  async getLead(btn: string, tfn: string, xheaders: any) {
    const response: any = await lastValueFrom(
      this.httpClient.get(`${Constants.APIS.CONTACT.GET}?btn=${encodeURIComponent(btn)}`)
    );
    this.lead = response;

    if (response) {
      let {
        FirstName,
        LastName,
        Address,
        Apartment,
        Email,
        City,
        State,
        Zip,
        ConfirmBtn,
        CallbackNumber,
        IsWorkbench,
        CustomerType,
        ResidentialType,
        HomeType,
      } = response.CustomerInfo;

      const scriptResetTFN = this.getScriptResetConfig('SCRIPT_RESET_TFNS');
      if (scriptResetTFN.includes(tfn)) {
        console.log(new Date().toLocaleString() + '  ➤  Resetting existing contact script');
        FirstName = '';
        LastName = '';
        Address = '';
        Email = '';
        CallbackNumber = '';
        City = '';
        Zip = '';
        State = '';
        Apartment = '';
        ResidentialType = '';
        CustomerType = '';
        HomeType = '';
      }

      if (ConfirmBtn == '') {
        ConfirmBtn = btn;
      }
      if (CallbackNumber == '') {
        CallbackNumber = btn;
      }

      if (this.callType == 'Inbound' && this.isFPLPhoneNumbers) {
        ConfirmBtn = '';
        CallbackNumber = '';
        this.greetingForm.controls['isConfirmPhoneNumber'].setValue(true)
        this.greetingForm.controls['confirmPhoneNumber'].addValidators([Validators.required]);

        this.greetingForm.controls['isConfirmCallbackNumber'].setValue(true)
        this.greetingForm.controls['confirmCallbackNumber'].addValidators([Validators.required]);

      }


      if (!this.greetingForm.controls['firstName'].value) {
        this.greetingForm.controls['firstName'].setValue(FirstName);
        this.lead.CustomerInfo.FirstName = FirstName ?? 'Unknown';
      } else {
        this.lead.CustomerInfo.FirstName = this.greetingForm.controls['firstName'].value;
      }
      if (!this.greetingForm.controls['lastName'].value) {
        this.greetingForm.controls['lastName'].setValue(LastName);
        this.lead.CustomerInfo.LastName = LastName ?? 'Number';
      } else {
        this.lead.CustomerInfo.LastName = this.greetingForm.controls['lastName'].value;
      }
      //* For Starlink Update
      if (this.isSTAR_LINK_Call) {
        if (!this.greetingForm.controls['customerType'].value) {
          this.greetingForm.controls['customerType'].setValue(CustomerType ? CustomerType : 'N');
        }
      }
      if (!this.addressForm.controls['email'].value) {
        this.addressForm.controls['email'].setValue(Email);
        this.lead.CustomerInfo.Email = Email;
      } else {
        this.lead.CustomerInfo.Email = this.addressForm.controls['email'].value;
      }
      let callback = '';
      if (CallbackNumber) {
        callback = CallbackNumber?.slice(this.countryCode.length) ?? '';
      } else {
        callback = ConfirmBtn?.slice(this.countryCode.length) ?? '';
      }

      this.addressForm.controls['address'].setValue(Address);
      this.addressForm.controls['city'].setValue(City);
      this.addressForm.controls['zip'].setValue(Zip);
      this.addressForm.controls['state'].setValue(State);
      this.addressForm.controls['apartment'].setValue(Apartment);

      this.greetingForm.controls['confirmPhoneNumber'].setValue(ConfirmBtn?.slice(this.countryCode.length) ?? '');
      this.greetingForm.controls['confirmCallbackNumber'].setValue(callback);
      this.lead.TotalCallMinutes = this.minutes_to_hhmm(response.TotalCallMinutes);
      this.lead.LastCallMinutes = this.minutes_to_hhmm(response.LastCallMinutes);

      this.addressForm.controls['customerType'].setValue(CustomerType ? CustomerType : 'N');
      this.addressForm.controls['resident'].setValue(ResidentialType ? ResidentialType : 'Residential');

      //* For PK Skills Dont Update
      if (!this.isPK_Call) {
        this.addressForm.controls['workoutBench'].setValue(IsWorkbench ? 'WithWorkBench' : 'WithoutWorkBench');
      }
      //* For Portmore Skills Dont Update if Outbound
      //* For PK Dont update
      // console.log(new Date().toLocaleString() + '  ➤  this.callType ==> ', this.callType);
      if (this.isPortmoreCall && !this.isPK_Call && this.callType === 'Outbound') {
        this.addressForm.controls['residentType'].setValue(HomeType ? HomeType : 'Owner');
      }

      if (this.getScriptSkillCode('PGESKILLCODE').includes(this.campaignCode)) {
        this.greetingForm.controls.utlitityConfirmationEmail.setValue(Email);
        this.greetingForm.controls.surveyEmail.setValue(Email);
      }
      if (this.callType == 'Inbound' && this.isSTAR_LINK_Call) {
        this.getHubspotContact(btn);
      }
      if (this.callType == 'Inbound' && this.isSierraCall) {
        console.log(new Date().toLocaleString() + '  ➤  Fetching Sierra Script for Headers ==> ', xheaders);
        if (xheaders['X-CallId'] && xheaders['X-BTN']) {
          console.log(new Date().toLocaleString() + '  ➤  Fetching Sierra Script for CallId ==> ', xheaders['X-CallId']);
          this.getSierraScript(xheaders['X-CallId'], btn, xheaders['CallSid']);
        }
      }

    }
    setTimeout(() => {
      if (this.showCallDetails) {
        this.showCallDetails = false;
        this.createForceDisposeLeadData(this.lead);
      }
    }, 5000);

  }

  async getUSHLeadInbound(btn: string, tfn: string, xheaders: any) {
    const response: any = await lastValueFrom(
      this.httpClient.get(`${Constants.APIS.CONTACT.GET}?btn=${encodeURIComponent(btn)}`)
    );
    this.lead = response;

    if (response) {
      const {
        FirstName,
        LastName,
        Address,
        Apartment,
        Email,
        City,
        State,
        Zip,
        ConfirmBtn,
        IsWorkbench,
        CustomerType,
        ResidentialType,
        HomeType,
      } = response.CustomerInfo;
      this.lead.TotalCallMinutes = this.minutes_to_hhmm(response.TotalCallMinutes);
      this.lead.LastCallMinutes = this.minutes_to_hhmm(response.LastCallMinutes);
    }

    if (this.callType == 'Inbound' && this.isFPLPhoneNumbers) {
      btn = '';
      this.greetingForm.controls['isConfirmPhoneNumber'].setValue(true)
      this.greetingForm.controls['confirmPhoneNumber'].addValidators([Validators.required]);
      this.greetingForm.controls['isConfirmCallbackNumber'].setValue(true)
      this.greetingForm.controls['confirmCallbackNumber'].addValidators([Validators.required]);
    }


    //* remove name from leads for ongoing call bar
    this.lead = this.lead || {};
    this.lead.CustomerInfo = this.lead.CustomerInfo || {};
    
    this.lead.CustomerInfo.FirstName = '-';
    this.lead.CustomerInfo.LastName = '-';
    this.greetingForm.controls['confirmPhoneNumber'].setValue(btn?.slice(this.countryCode.length) ?? '');
    this.greetingForm.controls['confirmCallbackNumber'].setValue(btn?.slice(this.countryCode.length) ?? '');


    if (this.callType == 'Inbound' && this.isSierraCall) {
      console.log(new Date().toLocaleString() + '  ➤  Fetching Sierra Script for Headers ==> ', xheaders);
      if (xheaders['X-CallId'] && xheaders['X-BTN']) {
        console.log(new Date().toLocaleString() + '  ➤  Fetching Sierra Script for CallId ==> ', xheaders['X-CallId']);
        this.getSierraScript(xheaders['X-CallId'], btn, xheaders['CallSid']);
      }
    }


    setTimeout(() => {
      if (this.showCallDetails) {
        this.showCallDetails = false;
        //*Ask Gk about this and call
        this.createForceDisposeLeadData(this.lead);
      }
    }, 5000);
  }
  onDispositionGroupChange(group: string) {
    this.dispositions = this.metadata?.Dispositions?.filter((x: any) => x.GroupName === group);
    if (this.callType.toLowerCase() == 'inbound' && this.isSTAR_LINK_Call) {
      this.dispositions = this.dispositions.filter((x: any) => x.Name.toLowerCase() != 'voicemail' && x.Name.toLowerCase() != 'ring no answer');
    }
    this.dispositions = naturalSensitiveSort(this.dispositions).asc('Name');
  }
  resetCampaign() {
    //reset metadata
    this.connectedCallObj = {};
    this.dispositions = [];
    this.transferNumbers = [];
    this.selectedDisposition = '';
    this.selectedDispositionGroup = '';
    this.selectedTimezone = '';
    this.campaignName.next('Campaign');
    //reset Script Forms & Data
    this.steps = this.stepsConstants;
    this.campaignCode = '';
    this.stepperIndex = 0;
    this.greetingForm.reset(this.initialGreetingFormValue);
    this.addressForm.reset(this.initialAddressFormValue);
    this.sales.clear();
    this.sales.push(this.createSaleFormGroup());
    this.salesForm.reset(this.initialSalesFormValue);
    this.addons = [];
    this.providerCustomerData = {};

    //dialPad Disposition Form
    this.dispositionForm.reset(this.initialDispositionFormValue);
    this.greeting = Constants.GREETING;
    this.isCallConnected.next(false);
    this.notes = '';
    this.btn = '';
    this.lead = {};
    this.lastCall = {};
    this.isCallAssigned = false;
    this.customerCallSid = '';

    //clear extra validations
    this.greetingForm.controls['utlitityConfirmationEmail'].clearValidators();
    this.greetingForm.controls['utlitityConfirmationEmail'].updateValueAndValidity();

    // reset script to default
    //this.isPGECall = false;
    //this.isPGESpanishCall = false;
    this.scriptName = 'default';

    //clear StarLink Fields
    this.showReasonDropDown = false;
    this.showOtherReasonTextBox = false;
    this.dispositionForm.controls['reasons'].clearValidators();
    this.dispositionForm.controls['reasons'].updateValueAndValidity();
    this.questionsAnsweres.clear();
    this.questionsAnsweres.push(this.createQuestionsFormGroup());

    //clear Ziply Fields
    this.greetingForm.controls['meetingSource'].clearValidators();
    this.greetingForm.controls['companyName'].clearValidators();
    this.greetingForm.controls['jobTitle'].clearValidators();
    this.greetingForm.controls['primaryInterest'].clearValidators();
    this.greetingForm.controls['currentProvider'].clearValidators();

    this.greetingForm.controls['meetingSource'].updateValueAndValidity();
    this.greetingForm.controls['companyName'].updateValueAndValidity();
    this.greetingForm.controls['jobTitle'].updateValueAndValidity();
    this.greetingForm.controls['primaryInterest'].updateValueAndValidity();
    this.greetingForm.controls['currentProvider'].updateValueAndValidity();

    this.dispositionForm.controls['chatTfn'].clearValidators();
    this.dispositionForm.controls['chatTfn'].updateValueAndValidity();

    this.salesForm.controls['chatTfn'].clearValidators();
    this.salesForm.controls['chatTfn'].updateValueAndValidity();

    this.showChatTfnTextbox = false;

    //Provider bits
    this.isPGECall = false;
    this.isPGESpanishCall = false;
    this.isFPL_NRG_Call = false;
    this.isSTAR_LINK_Call = false;
    this.isZIPLY_Call = false;
    this.isUSH_Call = false;
    this.isPortmoreCall = false;
    this.isNICCall = false;
    this.isAnyPortmoreSkill = false;
    this.isPK_Call = false;
    this.leadId = '';
    this.disableResidentRadio = false;
    this.conferenceSid = '';
    this.isSierraCall = false;
    this.sessionid = '';

    this.greetingForm.controls['confirmPhoneNumber'].clearValidators();
    this.greetingForm.controls['confirmPhoneNumber'].updateValueAndValidity();


    this.greetingForm.controls['confirmCallbackNumber'].clearValidators();
    this.greetingForm.controls['confirmCallbackNumber'].updateValueAndValidity();

    this.greetingForm.controls['isEmailOptout'].clearValidators();
    this.greetingForm.controls['isEmailOptout'].updateValueAndValidity();

    this.greetingForm.controls['email'].clearValidators();
    this.greetingForm.controls['email'].updateValueAndValidity();
    this.isEmailOptoutToggle = false;
    this.bdServiceableProviders = [];
    this.bdServiceableProviderMessages = [];
    this.dispositionCallbackSelection = '';
    this.isFPLPhoneNumbers = false;
  }

  // private getNow(datetime: Date, timeZone: string): momentTimezone.Moment {
  //     switch (timeZone) {
  //       case 'EST':
  //         return momentTimezone(datetime).tz('America/New_York');
  //       case 'CT':
  //         return momentTimezone(datetime).tz('America/Chicago');
  //       case 'MT':
  //         return momentTimezone(datetime).tz('America/Denver');
  //       case 'PT':
  //         return momentTimezone(datetime).tz('America/Los_Angeles');
  //       default:
  //         return momentTimezone(datetime);
  //     }
  //   };
  private getTimeZoneDate(datetime: string, timeZone: string): momentTimezone.Moment {
    switch (timeZone) {
      case 'EST':
        return momentTimezone.tz(datetime, 'MMMM Do YYYY, h:mm:ss a', 'America/New_York');
      case 'CT':
        return momentTimezone.tz(datetime, 'MMMM Do YYYY, h:mm:ss a', 'America/Chicago').tz('America/New_York');
      case 'MT':
        return momentTimezone.tz(datetime, 'MMMM Do YYYY, h:mm:ss a', 'America/Denver').tz('America/New_York');
      case 'PT':
        return momentTimezone.tz(datetime, 'MMMM Do YYYY, h:mm:ss a', 'America/Los_Angeles').tz('America/New_York');
      default:
        return momentTimezone.tz(datetime, 'MMMM Do YYYY, h:mm:ss a', 'America/New_York');
    }
  };
  async updateCallLead(callSid: any, ibexLead: any, callback: any) {
    if (!callSid) {
      console.log(new Date().toLocaleString() + '  ➤  Call data not updated due to empty lead id or callsid');
      return;
    }
    let disposition: any =
      this.dispositions.find((x: any) => x.Id == this.dispositionForm.controls['disposition'].value) || {};
    //* save last dialed Lead Id if finalized dispositions is selected
    if (disposition && this.starLinkFinalizedDispositions.includes(disposition?.Name || '')) {
      localStorage.setItem('current_dial_lead_id_to_remove', this.leadId);
    }
    let confirmNumber = this.btn;
    let callbackNumber = this.btn;
    if (this.isFPLPhoneNumbers) {
      confirmNumber = this.countryCode + this.getGreetingsFieldValue('confirmPhoneNumber');
      callbackNumber = this.countryCode + this.getGreetingsFieldValue('confirmCallbackNumber');
    }
    else {
      if (this.getGreetingsFieldValue('isConfirmPhoneNumber')) {
        confirmNumber = this.countryCode + this.getGreetingsFieldValue('confirmPhoneNumber');
      }
      if (this.getGreetingsFieldValue('isConfirmCallbackNumber')) {
        callbackNumber = this.countryCode + this.getGreetingsFieldValue('confirmCallbackNumber');
      }
    }

    let callbackTime: any = ''
    const isCallBack = this.dispositionCallbackSelection === 'Callback Scheduled';
    if (isCallBack) {
      const callbackTimezone = this.dispositionForm.get('callbackTimezone')?.value;
      let callbackDate = this.dispositionForm.get('callbackDate')?.value;
      const callbackHour = this.dispositionForm.get('callbackHour')?.value;
      const callbackMins = this.dispositionForm.get('callbackMins')?.value;
      const day = callbackDate.getDate();
      const month = callbackDate.getMonth();
      const year = callbackDate.getFullYear();
      const hour = Number(callbackHour);
      const minute = callbackMins;

      const timeZone: Record<string, string> = {
        'EST': 'America/New_York',
        'CT': 'America/Chicago',
        'MT': 'America/Denver',
        'PT': 'America/Los_Angeles'
      };
      const formatted = moment.tz({
        year: year,
        month: month,
        day: day,
        hour: hour,
        minute: +minute
      }, timeZone[callbackTimezone]).format('MMMM Do YYYY, h:mm:ss a');
      callbackTime = this.getTimeZoneDate(formatted, callbackTimezone).format();
    }
    let update = {
      LeadId: this.lead?.Id,
      CallSid: callSid,
      UserId: this.authService.authData.Id,
      Disposition: disposition,
      CallbackTime: callbackTime,
      CustomerInfo: {
        FirstName: this.greetingForm.controls['firstName'].value,
        LastName: this.greetingForm.controls['lastName'].value,
        Address: this.addressForm.controls['address'].value,
        Apartment: this.addressForm.controls['apartment'].value,
        City: this.addressForm.controls['city'].value,
        State: this.addressForm.controls['state'].value,
        Zip: this.addressForm.controls['zip'].value,
        Email: this.addressForm.controls['email'].value || this.greetingForm.controls['email'].value,
        IsWorkbench: this.addressForm.controls.workoutBench.value === 'WithoutWorkBench' ? false : true,
        CustomerType: this.isSTAR_LINK_Call ? this.greetingForm.controls.customerType.value : this.addressForm.controls.customerType.value,
        ResidentialType: this.addressForm.controls.resident.value,
        HomeType: this.addressForm.controls.residentType.value,
        MoveInDate: momentInst(this.greetingForm.controls['movingDate'].value).format('MM/DD/YYYY'), //this.greetingForm.controls['movingDate'].value, //momentInst(this.greetingForm.controls['movingDate'].value).format('YYYY-MM-DDTHH:mm:ssZ')
      },
      isEmailOptout: this.greetingForm.controls['isEmailOptout'].value,
      Note: this.notes,
      IsSale: this.salesForm.valid,
      IsOptIn: this.greetingForm.controls['isSendSummaryEmail'].value,
      SaleInfo: {
        Data: this.salesForm.valid
          ? this.salesForm.value.sales?.map((x) => ({
            Ocn: x.ocn,
            OfferType: x.offerType,
            Rgu: x.rgu,
            Mso: x.mso,
            DeviceCount: x.deviceCount ? x.deviceCount : 0,
            ConfirmationStatus: x.pkSaleConfrimation,
          }))
          : [],
        Addons: this.addons,
        SessionId: this.sessionid,
        AccountNumber: this.salesForm.value.accountNumber,
      },
      Survey: {
        Enable: this.greetingForm.controls['isSurveyTCPA'].value,
        Medium: this.greetingForm.controls['isSurveyTCPA'].value ? this.getSurveyMedium() : null,
        SurveyNumber: this.greetingForm.controls['isSurveyTCPA'].value
          ? this.greetingForm.controls['selectedSMSNumber'].value === 'Other'
            ? this.greetingForm.controls['surveyNumber'].value
            : this.greetingForm.controls['selectedSMSNumber'].value?.replace(/[()-]/g, '')
          : null,
        SurveyEmail: this.greetingForm.controls['isSurveyTCPA'].value
          ? this.greetingForm.controls['surveyEmail'].value
          : null,
      },
      ConfirmPhoneNumber: confirmNumber,
      ConfirmCallbackNumber: callbackNumber,
      IsPGECall: this.getScriptSkillCode('PGESKILLCODE').includes(this.campaignCode) ? true : false,
      ProvidersCustomerData:
        this.getScriptSkillCode('PGESKILLCODE').includes(this.campaignCode) && this.providerCustomerData
          ? this.providerCustomerData
          : null,
      TCPA: {
        Enable: this.dialpadService.tcpaEnable,
        Number: this.countryCode + this.dialpadService.tcpaNumber,
      },
      isVivintPitched: this.dialpadService.isVivintPitched,
      Integration: this.prepareIntegrationPostData(),
      OutboundLeadId: this.leadId,
      PrimaryCallSid: this.connectedCallObj.primary_call_sid,
      ConferenceSid: this.conferenceSid,
      ChatTfn: this.getChatTfn(),
      Username: this.authService.authData?.Username,
      IsFPLPhoneNumbers: this.isFPLPhoneNumbers
    };

    if (update.IsSale) {
      const rguSum = update?.SaleInfo?.Data?.reduce((accumulator: any, object: any) => {
        return accumulator + object.Rgu;
      }, 0);
      update.Disposition = {
        Name: `S${rguSum}`,
        GroupName: 'Sale',
        TermCode: `S${rguSum}`,
      };
      //await this.invokeAgentSale(update);
    }
    this.httpClient.post(`${Constants.APIS.CALL.UPDATE}`, update)
      .subscribe({
        next: async (data: any) => {
          if (update.IsSale) {
            await this.invokeAgentSale(update);
          }
          if (isCallBack) {
            // this.todayScheduledCallbacks(update);
            this.navService.todayScheduledCallbacks.isReload$.next(true);
          }
          if (!isCallBack && this.todayScheduledCallbacksDialingType === 'callback') {
            this.navService.todayScheduledCallbacks.isReload$.next(true);
          }
          this.todayScheduledCallbacksDialingType = '';
        },
        error: (error: any) => {
          // Handle error
          log.error('lead update error', error);
        },
        complete: () => {
          // Handle complete
          // No errors, route to new page here
          this.telephonyStateService.routeToLastDialedTarget();
        },
      });
    if (callback) {
      callback(callSid, update.Disposition.TermCode, this.cancelThirdParty, ibexLead, this.campaignCode);
    }
    this.resetCampaign();
    localStorage.removeItem('activeCallSid');
    localStorage.removeItem('fd_leadData');
  }
  private todayScheduledCallbacks(update: any) {
    const formattedTime = moment(update.CallbackTime).format();
    if (moment(formattedTime).isSame(moment(), 'day')) {
      const payload = {
        id: '',
        call_sid: update.CallSid,
        tfn: "",
        disposition: {
          "name": update.Disposition.Name
        },
        customer_info: {
          "first_name": update.CustomerInfo.FirstName,
          "last_name": update.CustomerInfo.LastName
        },
        "callback_info": {
          "time": moment(update.CallbackTime).format(),
          "is_completed": "No"
        },
        "CreatedOn": "",
        "Duration": 0,
        "direction": "",
        "CallbackNumber": update.ConfirmCallbackNumber,
        "Campaign": "",
        "CampaignCode": "",
        "CampaignId": "",
        "TFNCampaign": "",
        "TFNCampaignCode": "",
        "TFNCampaignId": "",
        "LanguageCode": null,
        "ConfirmBTN": update.ConfirmCallbackNumber,
        "LeadId": null,
        "CallSid": update.CallSid,
        "Direction": "",
        "Disposition": update.Disposition.Name,
        "TFN": ""
      }
      this.navService.todayScheduledCallbacks.apiItems.push(payload);
      this.navService.todayScheduledCallbacks.scheduledCallCount++;
      this.navService.todayScheduledCallbacks.localItems.push({
        id: update.CallSid,
        time: formattedTime
      });
    }
  }
  getChatTfn() {
    if (this.isChatSkillCall && this.salesForm.valid) {
      return this.countryCode + this.salesForm.controls['chatTfn']?.value;
    }
    return this.dispositionForm.controls['chatTfn']?.value ? this.countryCode + this.dispositionForm.controls['chatTfn']?.value : null
  }
  async updateContactInfo(callSid: string) {
    if (!callSid) {
      console.log(new Date().toLocaleString() + '  ➤  Contact data not updated due to empty lead id or callsid', this.lead, callSid);
      return;
    }
    if (!this.lead) return;

    let update = {
      Id: this.lead.Id,
      CallSid: callSid,
      CustomerInfo: {
        FirstName: this.greetingForm.controls['firstName'].value,
        LastName: this.greetingForm.controls['lastName'].value,
        Address: this.addressForm.controls['address'].value,
        Apartment: this.addressForm.controls['apartment'].value,
        City: this.addressForm.controls['city'].value,
        State: this.addressForm.controls['state'].value,
        Zip: this.addressForm.controls['zip'].value,
        Email: this.addressForm.controls['email'].value,
        IsWorkbench: this.addressForm.controls.workoutBench.value === 'WithoutWorkBench' ? false : true,
        CustomerType: this.addressForm.controls.customerType.value,
        ResidentialType: this.addressForm.controls.resident.value,
        HomeType: this.addressForm.controls.residentType.value,
        MoveInDate: momentInst(this.greetingForm.controls['movingDate'].value).format('MM/DD/YYYY'), //this.greetingForm.controls['movingDate'].value, //momentInst(this.greetingForm.controls['movingDate'].value).format('YYYY-MM-DDTHH:mm:ssZ')
      },
      ConfirmPhoneNumber: this.countryCode + this.greetingForm.controls['confirmPhoneNumber'].value,
      ConfirmCallbackNumber: this.countryCode + this.greetingForm.controls['confirmCallbackNumber'].value,
    };
    this.httpClient.post(`${Constants.APIS.CONTACT.UPDATE}/${this.lead.Id}`, update).subscribe({
      next: (data: any) => {

      },
      error: (error: any) => {
        console.log(new Date().toLocaleString() + '  ➤  contact update error', error);
      },
    });
  }
  async bdCallDisposition(callSid: string) {
    let isProviderCustomerEmpty = Object.keys(this.providerCustomerData).length === 0;
    if (isProviderCustomerEmpty) {
      return;
    }

    let salesObj = [];

    if (this.sales.value.length > 0) {
      if (this.salesForm.valid) {
        for (var i = 0; i < this.sales.value.length; i++) {
          let sale = {
            OCN: this.sales.value[i].ocn,
            ProviderCode: this.sales.value[i].mso,
          };
          if (sale.OCN != '') salesObj.push(sale);
        }
      }
    }

    let obj = {
      Ucid: callSid ?? "",
      Status: salesObj.length > 0 ? 'SaleCall' : 'NonSaleCall',
      ExternalId: this.providerCustomerData.externalId,
      AdditionalService: salesObj,
      Addons: this.addons?.map(function (ele) {
        return { ProviderCode: ele };
      }),
      Customer: {
        FirstName: this.greetingForm.controls['firstName'].value,
        LastName: this.greetingForm.controls['lastName'].value,
        EmailAddress: this.addressForm.controls['email'].value,
        ApartmentNumber: '',
        StreetAddress: this.addressForm.controls['address'].value,
        City: this.addressForm.controls['city'].value,
        State: this.addressForm.controls['state'].value,
        ZipCode: this.addressForm.controls['zip'].value,
        ContactNo: this.countryCode + this.greetingForm.controls['confirmPhoneNumber'].value,
      },
      CampaignCode: this.campaignCode,
    };

    const response: any = await lastValueFrom(
      this.httpClient.post(`${Constants.APIS.BUNDLEDEALER.PGE_CALL_DISPOSITION}`, obj)
    );
  }

  async getTFNDetail(tfn: string, lang_code: string) {
    const response: any = await lastValueFrom(
      this.httpClient.get(`${Constants.APIS.TFN.DETAIL}?tfn=${encodeURIComponent(tfn)}`, this.headers)
    );

    //this.bundleDealerSeassionParams.flow = response.MetaData.flow ? response.MetaData.flow : null;
    // this.tfnFlow = response.MetaData?.flow ? response.MetaData?.flow : null;
    this.tfnFlow = response?.MetaData?.flow ?? null;
    this.tfnCampaignId = response?.CampaignId ?? null
    // let responseGreeting = response.Settings.Call.Greetings.find((o: any) => o.LangCode === lang_code);
    let responseGreeting = response?.Settings?.Call?.Greetings?.find(
      (o: any) => o.LangCode === lang_code
    ) ?? null;
    //* Logic change if we found langCode then run the old code
    //* else go for 0 index if found
    if (responseGreeting) {
      this.greeting = responseGreeting;
    } else if (response && response.Settings.Call.Greetings.length > 0) {
      this.greeting = response.Settings.Call.Greetings[0];
    }
    console.log(this.greeting);
  }

  applyFormTouch() {
    switch (this.stepperIndex) {
      case 0:
        this.greetingForm.markAllAsTouched();
        break;
      case 1:
        this.greetingForm.markAllAsTouched();
        this.addressForm.markAllAsTouched();
        break;
      case 3:
        this.greetingForm.markAllAsTouched();
        this.addressForm.markAllAsTouched();
        this.salesForm.markAllAsTouched();
        break;
    }
    this.dispositionForm.markAllAsTouched();
  }
  setConfirmNumber(text: string): void {
    this.confirmNumber = text;
  }
  removeConfirmNumber() {
    this.confirmNumber = this.confirmNumber.replace(/.$/, '');
  }
  public toggleConfirmNumber(): void {
    this.isConfirmNumber = !this.confirmNumber;
  }
  async getLastCall(sid: string, btn: string) {
    if (!sid) {
      console.log(new Date().toLocaleString() + '  ➤  Last call information not fetched due to empty callsid');
      return;
    }
    const response: any = await lastValueFrom(
      this.httpClient.disableLoader().get(`${Constants.APIS.CALL.GET}/${sid}?btn=${encodeURIComponent(btn)}`, this.headers)
    );
    if (response) {
      const { Note, StartTime, EndTime } = response;
      // this.notes = Note ? Note : '';
      this.lastCall.Note = Note ?? '';
      this.lastCall.StartTime = momentInst(StartTime).format('MMMM Do YYYY, h:mm:ss a');
      this.lastCall.EndTime =
        momentInst(EndTime).year() === 1 ? '---------' : momentInst(EndTime).format('MMMM Do YYYY, h:mm:ss a');
    }
  }
  minutes_to_hhmm(numberOfMinutes: number) {
    //create duration object from moment.duration
    const duration = momentc().duration(numberOfMinutes, 'minutes');
    const hh = duration.years() * (365 * 24) + duration.months() * (30 * 24) + duration.days() * 24 + duration.hours();
    const mm = duration.minutes();
    const ss = duration.seconds();
    return `${appendLeadingZeros(hh)}:${appendLeadingZeros(mm)}:${appendLeadingZeros(ss)}`;
  }
  async invokeAgentSale(update: any) {
    let clientId = this.authService.authData.ClientId;
    let campaign = this.authService.getDefaultCampaign();
    let single = update?.SaleInfo?.Data?.filter((x: any) => x.Rgu === 1).length;
    let double = update?.SaleInfo?.Data?.filter((x: any) => x.Rgu === 2).length;
    let triple = update?.SaleInfo?.Data?.filter((x: any) => x.Rgu === 3).length;
    let quad = update?.SaleInfo?.Data?.filter((x: any) => x.Rgu === 4).length;
    const rguSum = update?.SaleInfo?.Data?.reduce((accumulator: any, object: any) => {
      return accumulator + object.Rgu;
    }, 0);
    // Calculate the sum of all Rgu values with Mso matching "HomeServe" case-insensitively
    const homeServeRguSum = update?.SaleInfo?.Data?.filter(
      (x: any) => x.Mso.toLowerCase() === 'homeserve'.toLowerCase()
    ).reduce((accumulator: any, object: any) => accumulator + object.Rgu, 0);

    await this.signalrService.invoke(RealTimeEvents.AgentSale, {
      ClientId: clientId,
      Email: update.CustomerInfo.Email,
      Campaign: campaign?.Code,
      Sales: update?.SaleInfo?.Data?.length,
      RGUs: rguSum,
      Single: single,
      Double: double,
      Triple: triple,
      Quad: quad,
      HomeServeRgu: homeServeRguSum,
      Username: this.authService.authData.Username
    });
  }
  assignCall(callSid: string, userId: string, ibexId: string, leadId: string) {
    if (!callSid) {
      console.log(new Date().toLocaleString() + '  ➤  Call not assigned due to empty callsid');
      return;
    }
    this.httpClient
      .disableLoader()
      .post(
        Constants.APIS.CALL.ASSIGN,
        {
          CallSid: callSid, UserId: userId, Date: momentInst().toISOString(), AgentId: ibexId, LeadId: leadId,
          DialingType: this.connectedCallObj.dialing_type
        },
        this.headers
      )
      .subscribe((x) => { });
  }

  checkSurveyValidation() {
    return (
      this.greetingForm.get('isSurveyTCPA')?.value &&
      !this.greetingForm.get('isSurveyByEmail')?.value &&
      !this.greetingForm.get('isSurveyByMobile')?.value
    );
  }

  createForceDisposeLeadData(lead: any) {
    const data = {
      LeadId: lead?.Id,
      CallSid: this.customerCallSid,
      UserId: this.authService.authData.Id,
      Disposition: {
        Name: 'Force Disposed',
        GroupName: 'System',
        TermCode: 'FD',
      },
      Duration: {},
      CustomerInfo: lead?.CustomerInfo,
      Note: '',
      IsSale: false,
      SaleInfo: {
        Data: [],
        Addons: [],
      },
      Survey: {
        Enable: false,
        Medium: null,
        SurveyNumber: null,
        SurveyEmail: null,
      },
      ConfirmPhoneNumber: lead?.CustomerInfo?.ConfirmBtn,
      ConfirmCallbackNumber: lead?.CustomerInfo?.ConfirmBtn,
      IsPGECall: this.getScriptSkillCode('PGESKILLCODE').includes(this.campaignCode) ? true : false,
      ProvidersCustomerData: null,
      TCPA: {
        Enable: false,
        Number: '',
      },
      Integration: this.prepareIntegrationPostData(),
      OutboundLeadId: this.leadId,
    };
    localStorage.setItem('fd_leadData', JSON.stringify(data));
  }

  //* Custom validator function to check for duplicates within FormGroup controls
  checkForDuplicatesOCN() {
    return (formArray: any): ValidationErrors | null => {
      const formGroupValues = formArray.controls.map((control: AbstractControl) => control.value);
      const duplicates = this.findDuplicatesOcnWithinGroup(formGroupValues);

      if (duplicates.length > 0) {
        //* Mark duplicate form controls with an error
        duplicates.forEach((duplicateValue) => {
          //* For empty
          if (duplicateValue.ocn.trim().length !== 0) {
            formArray.controls.forEach((control: FormGroup) => {
              if (control.value.ocn === duplicateValue.ocn) {
                control.setErrors({ duplicateValue: true });
              }
            });
          }
        });

        return { duplicateValues: true };
      }

      return null;
    };
  }

  //* Function to find duplicate values within FormGroups
  findDuplicatesOcnWithinGroup(array: any[]): any[] {
    const uniqueSet = new Set();
    const duplicates: any = [];
    array.forEach((value) => {
      if (uniqueSet.has(value.ocn)) {
        duplicates.push(value);
      } else {
        uniqueSet.add(value.ocn);
      }
    });

    return duplicates;
  }

  updateOCNDuplicateValidation() {
    const formArray = this.sales as FormArray;

    // Iterate through each form group in the form array
    formArray.controls.forEach((group: any) => {
      // Manually update the validation of other controls as needed
      const ocn = group.get('ocn');

      // Update the control's validation status
      ocn.updateValueAndValidity({ emitEvent: false });
    });
  }

  prepareIntegrationPostData() {
    let integration_props: any = { Database: {}, Provider: {} };
    //* HubSpot
    if (this.integrationService.isHubspotEnabled) {
      this.db_fields?.forEach((prop: any) => {
        switch (prop) {
          case 'Reasons':
            integration_props.Database[prop] = this.dispositionForm.controls['reasons']?.value?.join(',') || '';
            break;
          case 'LeadStatus':
            let disposition: any = this.dispositions?.find(
              (x: any) => x.Id == this.dispositionForm.controls['disposition'].value
            );
            integration_props.Database[prop] = disposition?.name || '';
            break;
          case 'OtherReasons':
            integration_props.Database[prop] = this.dispositionForm.controls['otherReasons'].value || '';
            break;
          case 'FirstName':
            integration_props.Database[prop] = this.greetingForm.controls['firstName'].value || '';
            break;
          case 'LastName':
            integration_props.Database[prop] = this.greetingForm.controls['lastName'].value || '';
            break;
          case 'AccountType':
            integration_props.Database[prop] = this.greetingForm.controls['accountType'].value || '';
            break;
          case 'AgentQuestions':
            integration_props.Database[prop] = JSON.stringify(
              this.greetingForm.controls['questionsAnsweres'].value || []
            );
            break;
        }
      });
      this.provider_fields?.forEach((prop: any) => {
        switch (prop) {
          case 'potential_reasons_for_not_purchasing':
            integration_props.Provider[prop] = this.dispositionForm.controls['reasons']?.value?.join(';') || '';
            break;
          case 'reason_for_not_purchasing__other_free_text_field_':
            integration_props.Provider[prop] = this.dispositionForm.controls['otherReasons'].value || '';
            break;
          case 'account_type':
            integration_props.Provider[prop] = this.greetingForm.controls['accountType'].value || '';
            break;
          case 'firstname':
            integration_props.Provider[prop] = this.greetingForm.controls['firstName'].value || '';
            break;
          case 'lastname':
            integration_props.Provider[prop] = this.greetingForm.controls['lastName'].value || '';
            break;
        }
      });
    }
    //* SaleForce
    else if (this.integrationService.isSalesForceEnabled) {
      this.db_fields?.forEach((prop: any) => {
        switch (prop) {
          case 'LeadStatus':
            let disposition: any = this.dispositions?.find(
              (x: any) => x.Id == this.dispositionForm.controls['disposition'].value
            );
            integration_props.Database[prop] = disposition?.name || '';
            break;
          case 'FirstName':
            integration_props.Database[prop] = this.greetingForm.controls['firstName'].value || '';
            break;
          case 'LastName':
            integration_props.Database[prop] = this.greetingForm.controls['lastName'].value || '';
            break;
          case 'MeetingSource':
            integration_props.Database[prop] = this.greetingForm.controls['meetingSource'].value || '';
            break;
          case 'PrimaryInterest':
            integration_props.Database[prop] = this.greetingForm.controls['primaryInterest'].value || '';
            break;
          case 'Company':
            integration_props.Database[prop] = this.greetingForm.controls['companyName'].value || '';
            break;
          case 'JobTitle':
            integration_props.Database[prop] = this.greetingForm.controls['jobTitle'].value || '';
            break;
          case 'AccountOwner':
            integration_props.Database[prop] = this.greetingForm.controls['accountOwner'].value || '';
            break;
          case 'Provider':
            integration_props.Database[prop] = this.greetingForm.controls['currentProvider'].value || '';
            break;
          case 'Email':
            integration_props.Database[prop] = this.greetingForm.controls['utlitityConfirmationEmail'].value || '';
            break;
          case 'Address':
            integration_props.Database[prop] = this.addressForm.controls['address'].value || '';
            break;
          case 'Country':
            integration_props.Database[prop] = 'United States';
            break;
          case 'City':
            integration_props.Database[prop] = this.addressForm.controls['city'].value || '';
            break;
          case 'State':
            integration_props.Database[prop] = this.addressForm.controls['state'].value || '';
            break;
          case 'ZipCode':
            integration_props.Database[prop] = this.addressForm.controls['zip'].value || '';
            break;
          case 'Reason':
            integration_props.Database[prop] = this.dispositionForm.controls['otherReasons'].value || '';
            break;
          case 'Description':
            integration_props.Database[prop] = this.greetingForm.controls['description'].value || '';
            break;
        }
      });
      this.provider_fields?.forEach((prop: any) => {
        switch (prop) {
          case 'FirstName':
            integration_props.Provider[prop] = this.greetingForm.controls['firstName'].value || '';
            break;
          case 'LastName':
            integration_props.Provider[prop] = this.greetingForm.controls['lastName'].value || '';
            break;
          case 'MeetingSource':
            integration_props.Provider[prop] = this.greetingForm.controls['meetingSource'].value || '';
            break;
          case 'PrimaryInterest':
            integration_props.Provider[prop] = this.greetingForm.controls['primaryInterest'].value || '';
            break;
          case 'Company':
            integration_props.Provider[prop] = this.greetingForm.controls['companyName'].value || '';
            break;
          case 'JobTitle':
            integration_props.Provider[prop] = this.greetingForm.controls['jobTitle'].value || '';
            break;
          case 'AccountOwner':
            integration_props.Database[prop] = this.greetingForm.controls['accountOwner'].value || '';
            break;
          case 'Provider':
            integration_props.Provider[prop] = this.greetingForm.controls['currentProvider'].value || '';
            break;
          case 'Email':
            integration_props.Provider[prop] = this.greetingForm.controls['utlitityConfirmationEmail'].value || '';
            break;
          case 'Address':
            integration_props.Provider[prop] = this.addressForm.controls['address'].value || '';
            break;
          case 'Country':
            integration_props.Provider[prop] = 'United States';
            break;
          case 'City':
            integration_props.Provider[prop] = this.addressForm.controls['city'].value || '';
            break;
          case 'State':
            integration_props.Provider[prop] = this.addressForm.controls['state'].value || '';
            break;
          case 'ZipCode':
            integration_props.Provider[prop] = this.addressForm.controls['zip'].value || '';
            break;
          case 'Reason':
            integration_props.Provider[prop] = this.dispositionForm.controls['otherReasons'].value || '';
            break;
          case 'Description':
            integration_props.Provider[prop] = this.greetingForm.controls['description'].value || '';
            break;
        }
      });
    }
    else if (this.integrationService.isTikTokEnabled) {
      this.db_fields?.forEach((prop: any) => {
        switch (prop) {
          case 'FirstName':
            integration_props.Database[prop] = this.greetingForm.controls['firstName'].value || '';
            break;
          case 'LastName':
            integration_props.Database[prop] = this.greetingForm.controls['lastName'].value || '';
            break;
        }
      });
    }
    return integration_props;
  }

  setProviderData(data: any) {
    const { AccountTypes, FinalizedDisposition, ReasonCodes, ProviderFieldsToUpdate, DatabaseFieldsToUpdate } = data;
    this.accountType = AccountTypes;
    this.reasons = ReasonCodes;
    this.finalizedDipositionsForReasons = FinalizedDisposition;
    this.provider_fields = ProviderFieldsToUpdate;
    this.db_fields = DatabaseFieldsToUpdate;
  }

  isFormValid(form: FormGroup): boolean {
    //* The validation status of the control. There are four possible validation status values:

    // VALID: This control has passed all validation checks.
    // INVALID: This control has failed at least one validation check.
    // PENDING: This control is in the midst of conducting a validation check.
    // DISABLED: This control is exempt from validation checks.

    return form.disabled ? true : form.valid;
  }

  providerBitActivition(btn: any, code: any, tfn: any) {
    //* FPL NRG Check Work if call is for FPL
    this.isFPL_NRG_Call = this.getScriptSkillCode('FPL_NRG_SKILLCODE').includes(code);
    //* PGE Check Work if call is for PGE
    this.isPGECall = this.getScriptSkillCode('PGESKILLCODE').includes(code);
    //* STARLINK Check Work if call is for STARLINK
    this.isSTAR_LINK_Call = this.getScriptSkillCode('STAR_LINK_SKILLCODE').includes(code);
    //* ZIPLY Check Work if call is for ZIPLY
    this.isZIPLY_Call = (this.getScriptSkillCode('ZIPLY_SKILLCODE') || '').includes(code);
    //* PORTMORE Check Work if call is for PORTMORE
    this.isUSH_Call = this.getScriptSkillCode('USH_SKILLCODE').includes(code);
    this.isPortmoreCall = this.getScriptSkillCode('PORTMORE_SKILLCODE').includes(code);
    this.isAnyPortmoreSkill = this.isUSH_Call || this.isPortmoreCall;
    //* PK
    this.isPK_Call = this.getScriptSkillCode('PK_SKILLCODE').includes(code);
    // NIC
    this.isNICCall = this.getScriptSkillCode('NIC_SKILLCODE').includes(code);
    //Tiktok
    this.isTikTokCall = this.getScriptSkillCode('TIKTOK_SKILLCODE').includes(code);

    this.isChatSkillCall = this.getScriptSkillCode('PKCHAT_SKILLCODE')?.includes(code)
    this.isSierraCall = this.getScriptSkillCode('SIERRA_SKILL_TFNS')?.includes(tfn);
    this.isFPLPhoneNumbers = this.getScriptSkillCode('FPL_BTNS')?.includes(btn) && this.callType == "Inbound";
  }

  getHubspotContact(btn: string) {
    this.httpClient.disableLoader().get(`${Constants.APIS.INTEGRATION.HUBSPOT.GET_CONTACT}?phone=${btn}`).subscribe({
      next: (response: any) => {
        const contacts = response.contacts;
        if (contacts.length > 0) {
          let contact = contacts[0];
          let email = contact.properties.email ? contact.properties.email.value : '';
          let firstname = contact.properties.firstname ? contact.properties.firstname.value : '';
          let lastname = contact.properties.lastname ? contact.properties.lastname.value : '';
          let account_type = contact.properties.account_type ? contact.properties.account_type.value : '';

          if (!this.greetingForm.controls['firstName'].value) {
            this.greetingForm.controls['firstName'].setValue(firstname);
          }
          if (!this.greetingForm.controls['lastName'].value) {
            this.greetingForm.controls['lastName'].setValue(lastname);
          }
          if (!this.addressForm.controls['email'].value) {
            this.addressForm.controls['email'].setValue(email);
          }
          if (!this.greetingForm.controls['accountType'].value) {
            this.greetingForm.controls['accountType'].setValue(account_type);
          }
        }
      },
      error: (error: any) => {
        console.log(new Date().toLocaleString() + '  ➤  contact get error', error);
      },
    });
  }

  getSierraScript(callSid: string, btn: string, parentCallSid: string) {
    this.httpClient.disableErrorHandler().disableLoader().get(`/sierra-call/customer-info?CallSid=${callSid}&PrimaryCallSid=${parentCallSid}`).subscribe({
      next: (response: any) => {
        if (!response) {
          console.log(new Date().toLocaleString() + '  ➤ Sierra contact get not found');
          return;
        }
        let names = response.Name?.split(' ');

        let firstname = names.length > 0 ? names[0] : response.Name;
        let lastName = names.length > 0 ? names[1] : '';
        this.lead.CustomerInfo.FirstName = firstname;
        this.lead.CustomerInfo.LastName = lastName;
        let summary = response.Summary || '';
        let callbackNumber = response.CallbackNumber || '';
        let currentProvider = response.CurrentProvider || '';
        let qualificationReason = response.QualificationReason || '';
        let requestedServices = response.RequestedServices || '';
        let serviceAddress = response.ServiceAddress || '';
        this.greetingForm.controls['firstName'].setValue(firstname);
        this.greetingForm.controls['lastName'].setValue(lastName);
        this.greetingForm.controls['summary'].setValue(summary);
        this.greetingForm.controls['confirmCallbackNumber'].setValue(callbackNumber);
        this.greetingForm.controls['currentProvider'].setValue(currentProvider);
        this.greetingForm.controls['qualificationReason'].setValue(qualificationReason);
        this.greetingForm.controls['requestedServices'].setValue(requestedServices);
        this.greetingForm.controls['serviceAddress'].setValue(serviceAddress);


        const geocoder = new google.maps.Geocoder();

        geocoder.geocode(
          { address: serviceAddress },
          (
            results: any,
            status: any
          ) => {

            if (status === "OK" && results[0]) {

              const parsedAddress: any = parseGoogleAddress(
                results[0].address_components
              );
              console.log(parsedAddress);
              this.addressForm.controls['address'].setValue(parsedAddress.fullAddress ? parsedAddress.fullAddress : serviceAddress);
              this.addressForm.controls['city'].setValue(parsedAddress.city);
              this.addressForm.controls['state'].setValue(parsedAddress.state);
              this.addressForm.controls['zip'].setValue(parsedAddress.zip);
              this.addressForm.controls['apartment'].setValue(parsedAddress.apartment);
            }
          }
        );


      },
      error: (error: any) => {
        console.log(new Date().toLocaleString() + '  ➤ Sierra contact get error', error);
      },
    });
  }

  setCountryCode(phoneNumber: string) {
    let countryCodes = this.appConfig.getByIdentifier('CountryDialingCodes').Fields;
    for (let i = 0; i < countryCodes.length; i++) {
      if (phoneNumber.startsWith(countryCodes[i].dialing_code)) {
        this.countryCode = countryCodes[i].dialing_code;
        return;
      }
    }
    this.countryCode = '+1'; // set +1 if no match is found
  }

  isZiplyFinalizedDispositionSelected(): boolean {
    let disposition: any = this.dispositions.find(
      (x: any) => x.Id == this.dispositionForm.controls['disposition'].value
    );
    return Constants.ZIPLY_FINALIZED_DISPOSITIONS.includes(disposition?.Name);
  }

  //* Mock Calls For QA/UX
  startMockCall() {
    this.isMockCall = true;
    let campaignId: string = '662bdf2f4b1e5da77f2e8be0';
    let callSid: string = '234234234jk23bn4kj';
    let callType: string = 'outbound';
    let btn: string = '+17029131466';
    let tfn: string = '+18885083770';
    let campaignCode: string = 'K01';
    let campaignName: string = 'StarLink';
    let langCode: string = 'en';
    const addons = [
      {
        Id: '63bf04894f36b56628d2b833',
        Name: 'ATT Wireless pitched and declined',
      },
      {
        Id: '63bf04894f36b56628d2b834',
        Name: 'ATT Wireless pitched and sold',
      },
      {
        Id: '63bf04894f36b56628d2b835',
        Name: 'ADT Pitched and Transferred',
      },
      {
        Id: '63bf04894f36b56628d2b836',
        Name: 'ADT Pitched and Declined',
      },
      {
        Id: '63bf04894f36b56628d2b837',
        Name: 'Transfer to Verizon',
      },
      {
        Id: '63bf04894f36b56628d2b838',
        Name: 'Home Serve Pitched and Transferred',
      },
      {
        Id: '63bf04894f36b56628d2b839',
        Name: 'Home Serve Pitched and Declined',
      },
      {
        Id: '63bf04894f36b56628d2b83a',
        Name: 'Spectrum Mobile Accepted and Transferred',
      },
      {
        Id: '63bf04894f36b56628d2b83b',
        Name: 'Spectrum Mobile Accepted and Customer will call back',
      },
      {
        Id: '63bf04894f36b56628d2b83c',
        Name: 'Spectrum Mobile declined / ineligible',
      },
      {
        Id: '63bf04894f36b56628d2b83d',
        Name: 'HOME SERVE PITCHED AND TRANSFERRED',
      },
      {
        Id: '63bf04894f36b56628d2b83e',
        Name: 'HOME SERVE PITCHED AND DECLINED',
      },
      {
        Id: '63bf04894f36b56628d2b83f',
        Name: 'HOME SERVE NOT ELIGIBLE',
      },
      {
        Id: '63bf04894f36b56628d2b840',
        Name: 'COMCAST LEAD GENERATED',
      },
      {
        Id: '63bf04894f36b56628d2b841',
        Name: 'ADT PITCHED AND LEAD GENERATED',
      },
      {
        Id: '63bf04894f36b56628d2b842',
        Name: 'ADT NOT APPLICABLE',
      },
      {
        Id: '63bf04894f36b56628d2b843',
        Name: 'FE Surge Pitched Accepted',
      },
      {
        Id: '63bf04894f36b56628d2b844',
        Name: 'FE Surge Pitched Declined',
      },
      {
        Id: '63bf04894f36b56628d2b845',
        Name: 'FE Surge - Unable to Pitch',
      },
      {
        Id: '63bf04894f36b56628d2b846',
        Name: 'CenturyLink E-Acceptance YES',
      },
      {
        Id: '63bf04894f36b56628d2b847',
        Name: 'CenturyLink E-Acceptance NO',
      },
      {
        Id: '63bf04894f36b56628d2b848',
        Name: 'CenturyLink N/A',
      },
      {
        Id: '63bf04894f36b56628d2b849',
        Name: 'FE Surge not Available',
      },
      {
        Id: '63bf04894f36b56628d2b84a',
        Name: 'DISH PITCHED AND TRANSFERRED',
      },
      {
        Id: '63bf04894f36b56628d2b84b',
        Name: 'DISH PITCHED AND DECLINED',
      },
      {
        Id: '63bf04894f36b56628d2b84c',
        Name: 'Dish Pitched and Not Eligible',
      },
      {
        Id: '63bf04894f36b56628d2b84d',
        Name: 'ALDER PITCHED AND TRANSFERRED',
      },
      {
        Id: '63bf04894f36b56628d2b84e',
        Name: 'ALDER PITCHED AND DECLINED',
      },
      {
        Id: '63bf04894f36b56628d2b84f',
        Name: 'ALDER NOT APPLICABLE',
      },
      {
        Id: '63bf04894f36b56628d2b850',
        Name: 'Customer Service – Marketing Opt Out',
      },
      {
        Id: '63bf04894f36b56628d2b851',
        Name: 'DISH PITCHED AND SOLD',
      },
    ];
    if (this.getScriptSkillCode('STAR_LINK2_SKILLCODE').includes(campaignCode)) {
      this.steps = this.starlinkInboundSteps;
    }
    if (callSid) {
      this.customerCallSid = callSid;
    }
    this.btn = btn;
    this.campaignCode = campaignCode;
    this.campaignName.next(campaignName);
    this.callType = callType;
    if (callType == 'outbound') {
      this.showCallDetails = true;
    }

    this.metadata = { Addons: addons };
    this.getCampainMetadata(campaignId);
    this.getTFNDetail(tfn, langCode);
    //* FPL Check Work if call is for FPL
    //this.isFPL_NRG_Call = Constants.FPL_NRG_SKILLCODE.includes(campaignCode);
    //* PGE Check Work if call is for PGE
    //this.isPGECall = Constants.PGESKILLCODE.includes(campaignCode);

    this.getLead(btn, '', '');
    //this.isPGECall && this.setupPGECall(btn, campaignCode);
    if (this.getScriptSkillCode('PGESKILLCODE').includes(campaignCode)) {
      this.greetingForm.controls['utlitityConfirmationEmail'].setValidators([Validators.required, Validators.email]);
      this.greetingForm.controls['utlitityConfirmationEmail'].updateValueAndValidity();
    }
    this.zone.run(() => {
      //this.scriptDecider();
      this.scriptName = 'star-link2';
      this.router.navigate(['/agent/calls/campaign']);
    });

    this.isCallConnected.next(true);

    //this.assignCall(this.customerCallSid, this.authService.authData.Id, '10372', '');
    //this.getLastCall(this.customerCallSid, this.btn);
  }

  getScriptSkillCode(attr: string): string {
    return this.appConfig.getByIdentifier('ScriptSkillCodesAndTFNS')?.Fields?.[attr] ?? Constants[attr];
  }

  hideAnyScriptFeature(code: string) {
    this.showNotes = this.authService.getAllCampaigns().find((c: any) => c.Code === code)?.Settings?.Note ?? true;
  }

  isFECallAndFEAddonsNotSelected(): boolean {
    let hasError: boolean = false;
    let isAnyPortmoreSkill = this.isPortmoreCall || this.isUSH_Call;
    let isFEAddonMustSelectTfn = (this.getScriptSkillCode('FEAddonMustSelect') || '').includes(
      this.connectedCallObj.tfn
    );

    if (isAnyPortmoreSkill && isFEAddonMustSelectTfn) {
      if (this.addons.length === 0) {
        hasError = true;
      } else {
        let isFEAddonsExist = this.addons.filter((a) => this.getScriptSkillCode('FEAddonsToCheck').includes(a));
        if (isFEAddonsExist.length == 0) {
          hasError = true;
        }
      }
    }
    return hasError;
  }

  isPKCallAndIsSaleAndPKAddonsNotSelected(): boolean {
    let hasError: boolean = false;

    if (this.isPK_Call) {
      if (this.addons.length === 0) {
        hasError = true;
      } else {
        let isPKddonsExist = this.addons.filter((a) => this.getScriptSkillCode('PKAddonsToCheck').includes(a));
        if (isPKddonsExist.length == 0) {
          hasError = true;
        }
      }
    }
    return hasError;
  }
  isPortmoreCallAndIsSaleAndAutoPayAddonsNotSelected(): boolean {
    let hasError: boolean = false;
    let call = this.isPortmoreCall || this.isNICCall || this.isPK_Call;
    if (this.salesForm.valid && call) {
      if (this.addons.length === 0) {
        hasError = true;
      } else {
        let isAutoAddonsExist = this.addons.filter((a) => this.getScriptSkillCode('AutoPayAddonsToCheck').includes(a));
        if (isAutoAddonsExist.length == 0) {
          hasError = true;
        }
      }
    }
    return hasError;
  }

  isFECallDirectionTfns(): boolean {
    return this.getScriptSkillCode('FEDirectCallTFNs').includes(this.connectedCallObj.tfn);
  }

  chnageWorkbenchToWithWorkBench() {
    let isWorkBenchTrue = this.getScriptSkillCode('DefaultsToWorkbenchTFNs').includes(this.connectedCallObj.tfn);
    isWorkBenchTrue && this.addressForm.controls['workoutBench'].setValue('WithWorkBench');
  }

  //* This is Function is For Ghost Call Disposition remove after some
  //* Interal of Call Connected
  ghostCallDispositionInterval() {
    let ghostCallConfig = this.appConfig.getByIdentifier('GhostCallDispositionSettings').Fields ?? {};
    if (ghostCallConfig && ghostCallConfig.isEnabled) {
      if (this.ghostCallTimeoutId) {
        this.cancelExecuteAfterRandomDelay();
      }
      this.executeAfterRandomDelay(ghostCallConfig.timeAfterHide, ghostCallConfig.timeAfterHide + 2, () => {
        this.metadata.Dispositions = this.metadata?.Dispositions?.filter(
          (x: any) => x.TermCode.toString().toLowerCase() !== 'gc' && x.Name.toString().toLowerCase() !== 'ghost call'
        );


        if (this.dispositionForm.controls['disposition'].value.toString().toLowerCase() === 'ghost call')
          this.dispositionForm.controls['disposition'].setValue('');
        if (this.dispositionForm.controls['dispositionGroup'].value) {
          this.dispositions = this.metadata?.Dispositions?.filter(
            (x: any) => x.GroupName === this.dispositionForm.controls['dispositionGroup'].value
          );
        } else {
          this.dispositions = [];
        }
      });
    }
  }

  executeAfterRandomDelay(start: number = 50, end: number = 90, callback: () => void): void {
    const getRandomDelay = () => Math.random() * (end - start) * 1000 + start * 1000;
    const delay = getRandomDelay();
    this.ghostCallTimeoutId = setTimeout(callback, delay);
  }

  cancelExecuteAfterRandomDelay(): void {
    clearTimeout(this.ghostCallTimeoutId);
    this.ghostCallTimeoutId = null;
  }

  navigateToCampaignRoute() {
    const currentUrl = this.router.url; // Get current URL
    const targetUrl: string = '/agent/calls/campaign';
    // console.log(new Date().toLocaleString() + '  ➤  currentUrl ==> ', currentUrl);
    // Compare the current URL with the target URL
    if (currentUrl !== targetUrl) {
      // Navigate back to campaign route
      this.router.navigate([targetUrl]);
    }
  }

  logCampaignScripts() {
    //console.log(new Date().toLocaleString() + '  ➤  this.connectedCallObj ==> ', this.connectedCallObj);

    //console.log(new Date().toLocaleString() + '  ➤  this.greetingForm.valid ==> ', this.greetingForm.valid);
    //console.log(new Date().toLocaleString() + '  ➤  this.greetingForm.controls ==> ', this.greetingForm.controls);
    //console.log(new Date().toLocaleString() + '  ➤  this.greetingForm.errors ==> ', this.greetingForm.errors);

    //console.log(new Date().toLocaleString() + '  ➤  this.addressForm.valid ==> ', this.addressForm.valid);
    //console.log(new Date().toLocaleString() + '  ➤  this.addressForm.controls ==> ', this.addressForm.controls);
    //console.log(new Date().toLocaleString() + '  ➤  this.addressForm.errors ==> ', this.addressForm.errors);

    //console.log(new Date().toLocaleString() + '  ➤  this.salesForm.valid ==> ', this.salesForm.valid);
    //console.log(new Date().toLocaleString() + '  ➤  this.salesForm.controls ==> ', this.salesForm.controls);
    //console.log(new Date().toLocaleString() + '  ➤  this.salesForm.errors ==> ', this.sales.errors);

    //console.log(new Date().toLocaleString() + '  ➤  this.isPGECall ==> ', this.isPGECall);
    //console.log(new Date().toLocaleString() + '  ➤  this.isPGESpanishCall ==> ', this.isPGESpanishCall);
    //console.log(new Date().toLocaleString() + '  ➤  this.isFPL_NRG_Call ==> ', this.isFPL_NRG_Call);
    //console.log(new Date().toLocaleString() + '  ➤  this.isSTAR_LINK_Call ==> ', this.isSTAR_LINK_Call);
    //console.log(new Date().toLocaleString() + '  ➤  this.isZIPLY_Call ==> ', this.isZIPLY_Call);
    //console.log(new Date().toLocaleString() + '  ➤  this.isUSH_Call ==> ', this.isUSH_Call);
    //console.log(new Date().toLocaleString() + '  ➤  this.isPK_Call ==> ', this.isPK_Call);
    //console.log(new Date().toLocaleString() + '  ➤  this.isPortmoreCall ==> ', this.isPortmoreCall);
    //console.log(new Date().toLocaleString() + '  ➤  this.isAnyPortmoreSkill ==> ', this.isAnyPortmoreSkill);
    if (this.greetingForm.invalid) {
      console.log(new Date().toLocaleString() + '  ➤  Greeting Form is invalid', this.greetingForm.errors);
    }
    if (this.addressForm.invalid) {
      console.log(new Date().toLocaleString() + '  ➤  Address Form is invalid', this.addressForm.errors);
    }
    if (this.salesForm.invalid) {
      console.log(new Date().toLocaleString() + '  ➤  Sales Form is invalid', this.salesForm.errors);
    }
  }
  disposeIbexCall(data: any) {
    const callSid = data.callSid;
    if (!callSid) {
      console.log(new Date().toLocaleString() + '  ➤  Call data not updated due to empty lead id or callsid', callSid);
      return;
    }
    let disposition: any =
      this.dispositions.find((x: any) => x.Id == this.dispositionForm.controls['disposition'].value) || {};
    if (data.lead && data.endCall) {
      let termCode = disposition?.TermCode || 'FD';

      if (this.salesForm.valid) {
        const saleInfo = {
          Data: this.salesForm.valid
            ? this.salesForm.value.sales?.map((x) => ({
              Rgu: x.rgu
            }))
            : [],
        };

        const rguSum = saleInfo?.Data?.reduce((accumulator: any, object: any) => {
          return accumulator + object.Rgu;
        }, 0);
        termCode = `S${rguSum}`;
      }
      data.lead.termcd = termCode;
      data.endCall(callSid, termCode, data.lead, this.telephonyStateService.cancelThirdParty);
    }
  }
  getScriptResetConfig(attr: string): string {
    return this.appConfig.getByIdentifier('ScriptSkillCodesAndTFNS')?.Fields?.[attr] ?? "";
  }
  phoneValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value || '';

    // remove all non-digits
    const digits = value.replace(/\D/g, '');

    // check full length (10 digits for US number)
    if (digits.length !== 10) {
      return { invalidPhone: true };
    }

    return null;
  }

  public removeNotification() {
    if (this.showCallDetails) {
      this.showCallDetails = false;
      this.createForceDisposeLeadData(this.lead);
    }
  }

  playAudio() {
    try {
      const audio = new Audio('/assets/audio/call-ringtone.mp3');
      audio.play();
    } catch (e) {
      console.log(e);
    }
  }

  isSaleAndBDServiceableProvidersAddonsNotSelected(): { isSelected: boolean; warning: string[] } {
    let isSelected = true;
    let warning: string[] = [];

    if (this.salesForm.valid) {
      const bdServiceableProviders: string[] = this.bdServiceableProviders;
      const addons: string[] = this.addons;
      const dbValues = this.appConfig.getByIdentifier('BDServiceableProviders')?.Fields as BdServiceableProvider[] ?? [];
      const mandatoryProviders = dbValues.filter(x => bdServiceableProviders.includes(x.provider) && x.isMandatory);
      const providersWithMissingAddons = mandatoryProviders.filter(provider =>
        !addons.some(addon =>
          provider.addons.some(providerAddon =>
            providerAddon.toLowerCase() === addon.toLowerCase()
          )
        )
      );

      if (providersWithMissingAddons.length > 0) {
        isSelected = false;
        warning = providersWithMissingAddons
          .map(x => x.warning);
      }
    }

    return { isSelected, warning };
  }

  getBDServiceableProviderMessage(): string[] {
    const bdServiceableProviders: string[] = this.bdServiceableProviders;
    const dbValues = this.appConfig.getByIdentifier('BDServiceableProviders')?.Fields as BdServiceableProvider[] ?? [];

    const providers = dbValues
      .filter(x => bdServiceableProviders.includes(x.provider))
      .map(x => x.provider);

    console.log(providers);

    return providers;
  }

  isFESurgeProgramTFNs(): boolean {
    return this.getScriptSkillCode('FESurgeProgramTFNs').includes(this.connectedCallObj.tfn);
  }
}
